export class WorkerRequestSender {
    postTarget;
    next_id = 0;
    pending = {};
    constructor(postTarget) {
        this.postTarget = postTarget;
        postTarget.addEventListener('message', (event) => {
            const message = event.data;
            if (message.type == 'resp') {
                const [resolve, reject] = this.pending[message.id];
                delete this.pending[message.id];
                if ('error' in message) {
                    reject(message.error);
                }
                if ('result' in message) {
                    resolve(message.result);
                }
            }
        });
    }
    post(request) {
        return new Promise((resolve, reject) => {
            const id = this.next_id++;
            this.pending[id] = [resolve, reject];
            this.postTarget.postMessage({
                type: 'req',
                id,
                data: request,
            });
        });
    }
}
//создаём принимателя запросов
export class RequestReceiver {
    constructor(postTarget, onMessage) {
        postTarget.addEventListener('message', async (event) => {
            if (event.data.type == 'req') {
                try {
                    const result = await onMessage(event.data.data);
                    postTarget.postMessage({
                        type: 'resp',
                        id: event.data.id,
                        result,
                    });
                }
                catch (e) {
                    postTarget.postMessage({
                        type: 'resp',
                        id: event.data.id,
                        error: e,
                    });
                }
            }
        });
    }
}
